import ReactOnRails from "react-on-rails"

import { withClientProviders } from "bundles/startup/common/withClientProviders"
import { withClientRenderer } from "bundles/startup/common/withClientRenderer"
import PortalApp from "portal/main"

ReactOnRails.register({
  PortalApp: withClientRenderer(withClientProviders(PortalApp)),
})
